/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V1CampaignPoliticalIndependentExpenditureFormPathSet {
    'requestId'?: string;
    'userId'?: string;
    'timestamp'?: Date;
    'campaignId'?: string;
    'orgId'?: string;
    'politicalIndependentExpenditureFormPath'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "campaignId",
            "baseName": "campaign_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "politicalIndependentExpenditureFormPath",
            "baseName": "political_independent_expenditure_form_path",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1CampaignPoliticalIndependentExpenditureFormPathSet.attributeTypeMap;
    }

    public constructor() {
    }
}

